import { TitreDescription } from '@components/titre-description/models';
import { Block } from '@shared/models';

export const titreDescriptionMock = (
  withTitle = true,
  withDescription = true,
  forceTitleSizeOnMobile: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | undefined = undefined,
  alignment: 'left' | 'center' | 'right' = 'left'
): Block<TitreDescription> => ({
  type: 'titre-description',
  data: {
    title: withTitle
      ? {
          text: `Les tendances\\\\[[Socoo'c]]`,
          as: 'h3',
        }
      : undefined,
    forceTitleSizeOnMobile: forceTitleSizeOnMobile,
    description: withDescription
      ? `Parce qu'un projet est <a href="https://shorturl.at/Wh0HR"><b>un travail d'équipe</b></a>, nous vous conseillons et vous accompagnons à chaque étape de la réalisation de votre cuisine.`
      : undefined,
    alignment,
  },
});
